import SheetLawyers from '@/pages/SpecialistPackage/SheetLawyers';
import SheetMedics from '@/pages/SpecialistPackage/SheetMedics';

export default [
    {
        path: '/paczka-prawnikow/:familyId',
        component: SheetLawyers,
        name: 'specialist-package-lawyers',
        meta: { requiresAuth: true },
        children: []
    },
    {
        path: '/paczka-medykow/:familyId',
        component: SheetMedics,
        name: 'specialist-package-medics',
        meta: { requiresAuth: true },
        children: []
    }
];
